module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/bg-bottom-590b20046be44d77085b7195d5b4bcb0.jpg";